import { createResetStateThunk } from 'library/redux/fileUpload/Thunks';

export const resetState = createResetStateThunk(
	'generateHealthCheckFiles/resetState',
	(s) => s.generateHealthCheckFiles
);
